<section class="content">
    <div class="content-block">
        <div class="row clearfix">
            <div class="col-lg-4 col-md-12">
                <div class="card">
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="card">

                    <div class="card-body p-3">

                        <div class="row">
                            <div class="col col-md-4">
                                <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
                                    <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
                                </app-benef-info>
                            </div>
                            <div class="col col-md-8">
                                <div class="mt-2">

                                    <div style="max-height: 200px;overflow-y: auto;">
                                        <table class="prescription-table">
                                            <thead>
                                                <tr>
                                                    <th scope="col"># <i class="fa fa-redo"
                                                            (click)="getItemsPrescriptionActive()"></i></th>
                                                    <th scope="col">Libelle</th>
                                                    <th scope="col">Date consultation</th>
                                                    <th scope="col">Date expiration</th>
                                                    <!-- <th scope="col">Fichier</th> -->
                                                    <th scope="col"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr [class.active-row]="item.is_active"
                                                    *ngFor="let item of itemsPrescription; let i = index"
                                                    (click)="onSelectRow(item)">
                                                    <th>{{ i + 1 }}</th>
                                                    <!-- <td>{{ item.codification }}</td> -->
                                                    <td>{{ item.libelle }}</td>
                                                    <td>{{ item.created_at | date:'dd/MM/yyyy' }}</td>
                                                    <td>
                                                        <!-- Add expiration date if available -->
                                                        {{ item.date_expiration ? (item.date_expiration |
                                                        date:'dd/MM/yyyy')
                                                        : 'N/A' }}
                                                    </td>
                                                    <!-- <td class="blink">
                                                        <a *ngIf="item.image_url" target="_blank" [href]="item.image_url" style="text-decoration: underline;">Télécharger</a>
                                                    </td> -->
                                                    <td class="blink">
                                                        {{ item.is_controle?'Controle':'' }}
                                                    </td>
                                                </tr>
                                                <tr *ngIf="!itemsPrescription || !itemsPrescription.length">
                                                    <td colspan="6" style="text-align: center;">
                                                        Auncune donnée trouvée
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <hr>

                                    <!-- Medication Add Form -->
                                    <div class="card mb-4" *ngIf="selectedConsultation && selectedConsultation.id">
                                        <div class="card-body">
                                            <div class="d-flex gap-2 mb-3">
                                                <span class="badge bg-success">Garanti</span>
                                                <span class="badge bg-warning text-dark">Entente préalable</span>
                                                <span class="badge bg-danger">Non garanti</span>
                                            </div>
                                            <form (ngSubmit)="addMedicament()">
                                                <div class="row g-3 align-items-end">
                                                    <div class="col-md-4">
                                                        <label class="form-label fw-semibold">Médicament</label>
                                                        <app-search-mdicament-pro
                                                            [cancelItemSelected]="cancelItemSelected"
                                                            (itemMedicamentSelected)="onSelectMedocPro($event)">
                                                        </app-search-mdicament-pro>
                                                    </div>
                                                    <!-- <div class="col-md-2">
                                                        <label class="form-label fw-semibold">Forme</label>
                                                        <input disabled type="text" class="form-control form-control-sm"
                                                            [(ngModel)]="selectedMedoc.forme_medicament_libelle"
                                                            name="forme_medicament_libelle">
                                                    </div> -->
                                                    <div class="col-md-2">
                                                        <label class="form-label fw-semibold">Quantité</label>
                                                        <input mask="separator" type="text"
                                                            class="form-control form-control-sm"
                                                            [(ngModel)]="itemToAdd.quantite" name="quantite" required>
                                                    </div>
                                                    <div class="col-md-3" style="position:relative;">
                                                        <label
                                                            class="form-label fw-semibold d-flex align-items-center justify-content-between">
                                                            Posologie
                                                            <button type="button" class="btn-suggest"
                                                                [disabled]="!selectedMedoc?.id"
                                                                (click)="openPosologieSuggestions()"
                                                                [title]="selectedMedoc?.id ? 'Voir suggestions posologie' : 'Sélectionnez un médicament d\'abord'">
                                                                <i class="fas fa-lightbulb"></i>
                                                            </button>
                                                        </label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            [(ngModel)]="itemToAdd.posologie" name="posologie" required>
                                                        <!-- Backdrop fermeture dropdown -->
                                                        <div *ngIf="showPosologieSuggestions"
                                                            style="position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9998;"
                                                            (click)="showPosologieSuggestions = false"></div>
                                                        <!-- Dropdown suggestions -->
                                                        <div class="suggest-dropdown" *ngIf="showPosologieSuggestions">
                                                            <div class="suggest-dropdown-list">
                                                                <div class="suggest-dropdown-item"
                                                                    *ngFor="let s of posologieSuggestions"
                                                                    [class.active]="selectedSuggestionText === s.text"
                                                                    (click)="selectedSuggestionText = s.text; $event.stopPropagation()">
                                                                    {{ s.text }}
                                                                </div>
                                                            </div>
                                                            <div class="suggest-dropdown-edit"
                                                                *ngIf="selectedSuggestionText">
                                                                <textarea class="form-control form-control-sm" rows="2"
                                                                    [(ngModel)]="selectedSuggestionText"
                                                                    [ngModelOptions]="{standalone:true}"
                                                                    (click)="$event.stopPropagation()"></textarea>
                                                                <button type="button"
                                                                    class="btn btn-sm btn-success suggest-apply-btn"
                                                                    (click)="itemToAdd.posologie = selectedSuggestionText; showPosologieSuggestions = false; $event.stopPropagation()">
                                                                    <i class="fas fa-check me-1"></i>Appliquer
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label class="form-label fw-semibold">Durée (jrs)</label>
                                                        <input mask="separator" type="text"
                                                            class="form-control form-control-sm"
                                                            [(ngModel)]="itemToAdd.duree" name="duree" required>
                                                    </div>
                                                    <div class="col-md-1">
                                                        <button type="submit" class="btn btn-primary btn-sm w-100">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                            <!-- <br> -->
                                            <hr>

                                            <table class="table table-hover table-bordered mb-0 medication-table">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th width="25">#</th>
                                                        <th>Produit</th>
                                                        <th width="45">Qté</th>
                                                        <th>Posologie</th>
                                                        <th width="50">Durée</th>
                                                        <th width="80">Renouveler?</th>
                                                        <th width="80">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container *ngFor="let item of itemsMedicament; let i=index">
                                                        <!-- Ligne principale -->
                                                        <tr [ngClass]="{
                                                            'table-warning': item.is_entente_prealable,
                                                            'table-danger': item.is_exclu,
                                                            'table-success': !item.is_exclu && !item.is_entente_prealable
                                                        }">
                                                            <td>{{ i+1 }}</td>
                                                            <td>
                                                                <span *ngIf="item.forme_medicament_libelle"
                                                                    class="forme-tag">{{ item.forme_medicament_libelle
                                                                    }}</span>
                                                                {{ item.medicament_libelle }}
                                                            </td>
                                                            <td class="text-end">{{ item.quantite }}</td>
                                                            <td class="posologie-cell"
                                                                (click)="selectedPosologie = item.posologie; $event.stopPropagation()">
                                                                <span class="posologie-truncated">{{ item.posologie
                                                                    }}</span>
                                                                <i class="fas fa-eye posologie-icon"></i>
                                                            </td>
                                                            <td class="text-end">{{ item.duree }}</td>
                                                            <td>
                                                                <select [disabled]="item.is_exclu"
                                                                    class="form-select form-select-sm"
                                                                    [(ngModel)]="item.is_renewable"
                                                                    [ngModelOptions]="{standalone:true}"
                                                                    (change)="item.is_renewable == 1 || item.is_renewable == '1' ? selectedDetailItem = item : null">
                                                                    <option value="1">Oui</option>
                                                                    <option value="0">Non</option>
                                                                </select>
                                                            </td>
                                                            <td class="text-center">
                                                                <div class="d-flex gap-1 justify-content-center">
                                                                    <button
                                                                        (click)="selectedDetailItem = item; $event.stopPropagation()"
                                                                        class="btn btn-xs"
                                                                        [class.btn-info]="item.is_renewable == 1 || item.is_renewable == '1'"
                                                                        [class.btn-outline-secondary]="item.is_renewable != 1 && item.is_renewable != '1'"
                                                                        [disabled]="item.is_renewable != 1 && item.is_renewable != '1'"
                                                                        title="Détail renouvellement">
                                                                        <i class="fas fa-sync-alt"></i>
                                                                    </button>
                                                                    <button (click)="itemsMedicament.splice(i,1)"
                                                                        class="btn btn-danger btn-xs" title="Supprimer">
                                                                        <i class="fas fa-trash-alt"></i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <tr *ngIf="!itemsMedicament?.length">
                                                        <td colspan="7" class="text-center py-4 text-muted">
                                                            <i class="fas fa-info-circle me-2"></i>Aucun médicament
                                                            ajouté
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <br>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <app-scroll-search-affection
                                                        (onSelectAffection)="onSelectAffection($event)"></app-scroll-search-affection>

                                                </div>
                                                <div class="col-md-6">
                                                    <input (change)="uploadFile($event)" type="file"
                                                        class="form-control" id="fichier1" name="fichier1">
                                                    <!-- <label class="input-group-text" for="fichier1">Fichier</label> -->
                                                </div>
                                                <!-- <div class="col-md-2" style="visibility: hidden;">
                                                    <ng-select disabled [items]="itemsModePrescription"
                                                        bindLabel="libelle" bindValue="code"
                                                        [(ngModel)]="itemToSave.mode_prescription"
                                                        placeholder="Mode prescription" class="form-control-sm">
                                                    </ng-select>
                                                </div> -->
                                            </div>
                                            <!-- </div> -->
                                            <div class="row mt-2">
                                                <div class="col-md-12">
                                                    <label class="form-label fw-semibold">Praticien</label>
                                                    <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id"
                                                        [(ngModel)]="itemToSave.praticien_id"
                                                        placeholder="Sélectionnez le praticien"
                                                        class="form-control-sm">
                                                    </ng-select>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-end mt-4">
                                                <button style="width: 100%;"
                                                    [disabled]="!itemsMedicament?.length || !is_affection_valid"
                                                    (click)="confirmSaveItem(itemToSave)"
                                                    class="btn px-4 btn-success btn-lg submit-btn">
                                                    <i class="fas fa-paper-plane me-2"></i>Soumettre la prescription
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Popup détail renouvellement -->
    <div class="posologie-overlay" *ngIf="selectedDetailItem">
        <div class="posologie-popup detail-popup" (click)="$event.stopPropagation()">
            <div class="posologie-popup-header">
                <span>Renouvellement — {{ selectedDetailItem.medicament_libelle }}</span>
                <button (click)="selectedDetailItem = null">&times;</button>
            </div>
            <div class="posologie-popup-body">
                <div class="detail-grid">
                    <!-- <div class="detail-field">
                        <label>Renouveler ?</label>
                        <select class="form-select form-select-sm" [(ngModel)]="selectedDetailItem.is_renewable"
                            [ngModelOptions]="{standalone:true}">
                            <option value="1">Oui</option>
                            <option value="0">Non</option>
                        </select>
                    </div> -->
                    <div class="detail-field">
                        <label>Renouveller tous les (en jour)</label>
                        <input type="number" min="1" class="form-control form-control-sm"
                            [(ngModel)]="selectedDetailItem.frequence_renew" [ngModelOptions]="{standalone:true}"
                            [disabled]="selectedDetailItem.is_renewable == 0"
                            (keypress)="'0123456789'.includes($event.key) ? true : $event.preventDefault()">
                    </div>
                    <div class="detail-field">
                        <label>Durée renouvellement (jr)</label>
                        <input type="number" min="1" class="form-control form-control-sm"
                            [(ngModel)]="selectedDetailItem.duree_renew" [ngModelOptions]="{standalone:true}"
                            [disabled]="selectedDetailItem.is_renewable == 0"
                            (keypress)="'0123456789'.includes($event.key) ? true : $event.preventDefault()"
                            [class.is-invalid]="selectedDetailItem.duree_renew && selectedDetailItem.frequence_renew && +selectedDetailItem.duree_renew <= +selectedDetailItem.frequence_renew">
                        <div class="invalid-feedback" style="font-size:11px;">
                            La durée doit être supérieure à la fréquence.
                        </div>
                    </div>
                    <div class="detail-field">
                        <label>
                            Quantité à renouveller
                            <span *ngIf="selectedDetailItem.quantite" style="font-size:10px;color:#888;">(max : {{
                                selectedDetailItem.quantite }})</span>
                        </label>
                        <input type="number" min="1" class="form-control form-control-sm"
                            [(ngModel)]="selectedDetailItem.quantite_renew" [ngModelOptions]="{standalone:true}"
                            [disabled]="selectedDetailItem.is_renewable == 0"
                            (keypress)="'0123456789'.includes($event.key) ? true : $event.preventDefault()"
                            [class.is-invalid]="selectedDetailItem.quantite_renew && selectedDetailItem.quantite && +selectedDetailItem.quantite_renew > +selectedDetailItem.quantite">
                        <div class="invalid-feedback" style="font-size:11px;">
                            Ne peut pas dépasser la quantité prescrite ({{ selectedDetailItem.quantite }}).
                        </div>
                    </div>
                    <div class="detail-field">
                        <label>Consultation préalable ?</label>
                        <select class="form-select form-select-sm"
                            [(ngModel)]="selectedDetailItem.is_consultation_required_renew"
                            [ngModelOptions]="{standalone:true}" [disabled]="selectedDetailItem.is_renewable == 0">
                            <option value="1">Oui</option>
                            <option value="0">Non</option>
                        </select>
                    </div>
                </div>
                <!-- Récapitulatif renouvellements possibles -->
                <div class="renew-summary"
                    *ngIf="selectedDetailItem.frequence_renew && selectedDetailItem.duree_renew && +selectedDetailItem.duree_renew > +selectedDetailItem.frequence_renew">
                    <i class="fas fa-sync-alt me-1"></i>
                    Renouvellements possibles :
                    <strong>{{ (selectedDetailItem.duree_renew / selectedDetailItem.frequence_renew) | number:'1.0-0'
                        }}</strong>
                    fois
                    <span class="text-muted" style="font-size:11px;">
                        ({{ selectedDetailItem.duree_renew }} jr ÷ {{ selectedDetailItem.frequence_renew }} jr)
                    </span>
                </div>
                <div class="d-flex justify-content-end mt-3">
                    <button type="button" class="btn btn-primary btn-sm px-4" (click)="selectedDetailItem = null">
                        <i class="fas fa-check me-1"></i> OK
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Popup posologie -->
    <div class="posologie-overlay" *ngIf="selectedPosologie" (click)="selectedPosologie = ''">
        <div class="posologie-popup" (click)="$event.stopPropagation()">
            <div class="posologie-popup-header">
                <span>Posologie</span>
                <button (click)="selectedPosologie = ''">&times;</button>
            </div>
            <div class="posologie-popup-body">{{ selectedPosologie }}</div>
        </div>
    </div>

</section>